module.exports = __webpack_public_path__ + "static/media/hair-dryer.269c0e7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hair-dryer.png
// module id = 1056
// module chunks = 0